import React, { useEffect } from 'react';
import { message, Table as TableDefault } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ADMIN_GET_COUNTRIES } from 'graphql/queries';

import columns from './columns';

const Table: React.FC<RouteComponentProps> = () => {
  const { data, error, loading } = useQuery(ADMIN_GET_COUNTRIES);

  useEffect(() => {
    if (error) {
      message.error(error);
    }
  }, [error]);

  return (
    <TableDefault
      dataSource={data && data.country}
      columns={columns}
      loading={loading}
      rowKey="id"
    />
  );
};

export default withRouter(Table);
